module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.library.js
// module id = 96
// module chunks = 15